import { createSelector } from '@base-ui/utils/store';
export const eventCalendarViewSelectors = {
  view: createSelector(state => state.view),
  views: createSelector(state => state.views),
  hasDayView: createSelector(state => state.views.includes('day'))
};